/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import 'normalize.css'
import './src/styles/index.scss'
import 'react-slideshow-image/dist/styles.css'
